import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { getAllCompanies } from 'store/state/companies';
import {
  Dialog, DialogTitle, DialogContent,
  Fade,
  DialogActions,
  Grid,
  Select,
  MenuItem
} from '@material-ui/core';
import styled from 'styled-components';
import { PrimaryButton } from 'components/Global/Buttons';

const Spacer = styled.div`
  flex-grow: 1;
`;

const StyledCancelButton = styled(PrimaryButton)`
  &&& {
    margin-right: 12px;
  }
`;

export const VerticalDivider = styled.div`
  height: 100%;
  border-right: 1px solid #cccccc;
`;

const Error = styled.div`
  color: #ff0000;
  font-size: 17px;
  padding-left: 8px;
`;

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
`;

class CompanyModal extends Component {
  state = {
    companyId: ''
  }

  handleClose = () => {
    this.props.onClose();
    this.setState({ companyId: '' });
  }

  render() {
    const { isOpen, errorMessage, companies, onSubmit } = this.props;
    const { companyId } = this.state;
    return (
      <>
        <Dialog
          open={isOpen}
          onClose={this.handleClose}
          style={{
            height: '400px'
          }}
          maxWidth='md'>
          <Grid
            container
            alignItems='center'
            justify='space-between'>
            <DialogTitle>Choose Portfolio</DialogTitle>
          </Grid>
          <DialogContent>
            <Select
              value={companyId}
              variant='filled'
              style={{ minWidth: '256px' }}
              onChange={(event) => {
                let state = this.state;
                state.companyId = event.target.value;
                this.setState({ companyId: event.target.value });
              }}>
              <MenuItem value='' disabled>Select a company</MenuItem>
              {companies?.map((company, idx) => (
                <MenuItem value={company.id} key={idx}>{company.name}</MenuItem>
              ))}
            </Select>
          </DialogContent>
          <StyledDialogActions>
            <Fade in={!!errorMessage}>
              <Error>{errorMessage}</Error>
            </Fade>
            <Spacer></Spacer>
            <>
              <StyledCancelButton onClick={this.handleClose}>Cancel</StyledCancelButton>
              <StyledCancelButton onClick={() => { onSubmit(companyId) }}>Recalculate</StyledCancelButton>
            </>
          </StyledDialogActions>
        </Dialog>
      </>
    )
  }
}
const mapStateToProps = ({ companies }) => ({ companies: companies.allCompanies ? companies.allCompanies.companies : [] });

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    { getAllCompanies }
  )
)(CompanyModal);
